<template>
  <div :class="['pager', className]">
    <div class="pager-summary">
        ({{ itemsLength }} Results)
        <!--{{ this.lastPage }} Pages -->
    </div>
    <ul 
      v-if="itemsLength > itemsPerPage"
      class="pager-pages">
        <li key="previous">
            <button
                :class="['pager-button', { isInActive: activeIndex - itemsPerPage < 0 }]"                
                :disabled="activeIndex - itemsPerPage < 0"
                @click="$emit('page-to', activeIndex - itemsPerPage)"
                >
                <span class="isVisuallyHidden">previous</span>
                <i class="icon icon_arrow icon_arrow_left"></i>
            </button>
        </li>
        <li key="previous-ellipses" v-if="lastPage > pageOptionsToShow && currentPage - delta >= 1">
            <button class="pager-button isInActive" disabled="true">...</button>
        </li>
        <li v-for="page in pageArray" :key="page" class="pager-pages-page">
            <button 
                @click="$emit('page-to', page * itemsPerPage)"
                :class="[{ isActive: page * itemsPerPage === activeIndex }]"
                :disabled="page * itemsPerPage === activeIndex"
            >{{page + 1}}</button>
        </li>
        <li key="next-ellipses" v-if="lastPage > pageOptionsToShow && lastPage - currentPage >= delta + 2">
            <button class="pager-button isInActive" disabled="true">...</button>
        </li>
        <li>
            <button
                :class="['pager-button', { isInActive: activeIndex + itemsPerPage >= itemsLength }]"
                :disabled="activeIndex + itemsPerPage >= itemsLength"
                @click="$emit('page-to', activeIndex + itemsPerPage)"
                >
                <span class="isVisuallyHidden">next</span>
                <i class="icon icon_arrow icon_arrow_right"></i>
            </button>
        </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    itemsLength: Number,
    itemsPerPage: Number,
    activeIndex: Number,
    pageOptionsToShow: {
      type: Number,
      default: 9
    },
    className: String,
    orientation: String
  },
  computed: {
    delta() {
      return Math.floor(this.pageOptionsToShow / 2);
    },
    currentPage() {
      return this.activeIndex / this.itemsPerPage;
    },
    lastPage() {
      return Math.ceil(this.itemsLength / this.itemsPerPage);
    },
    pageArray() {
      let pageArray = [];
      let last = 0;
      let first = 0;

      if (this.lastPage <= this.pageOptionsToShow) {
        first = 0;
        last = this.lastPage - 1;
      } else if (this.currentPage <= this.delta) {
        last = this.pageOptionsToShow - 1;
        first = 0;
      } else if (this.currentPage >= this.lastPage - this.delta) {
        last = this.lastPage - 1;
        first = this.lastPage - this.pageOptionsToShow;
      } else {
        last = this.currentPage + this.delta;
        first = this.currentPage - this.delta;
      }

      for (let index = first; index <= last; index++) {
        pageArray.push(index);
      }

      //return an array of numbers representing pages
      return pageArray;
    }
  }
};
</script>

<style lang="scss">
</style>

